import { render, staticRenderFns } from "./DutyCard.vue?vue&type=template&id=0da90b90&"
import script from "./DutyCard.vue?vue&type=script&lang=js&"
export * from "./DutyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports